<template>
    <div class="inner-main">
        <div class="header">
            <span class="iconfont iconarrowleft-outline back-info" @click="goBack"></span>
        </div>
        <div class="main">
            <div class="fundding">
                <div class="news-title">
                    {{$t("existEventIPO")}}
                </div>
                <div class="filter">
                    <div id="industry-filter1" class="left" @click="showSearch(1)">行业领域 <i class="iconfont icondown-chevron-outline"></i> </div>
                    <div class="center" @click="changeTimeOrder">上市时间 <i class="iconfont icondown-chevron-outline" style=" display: inline-block;" :class="{'anim':isUp ,'anim-reset':!isUp}"></i></div>
                    <div id="stocking-location-filter1" class="right" @click="showSearch(2)">上市地点 <i class="iconfont icondown-chevron-outline"></i></div>

                    <van-popup v-model="showSearchPanel" position="right" :style="{ height: '100%', width: '80%' }">
                        <search-panel :type="searchPanelType" @search="searchByPanel"></search-panel>
                    </van-popup>
                    <van-popup v-model="showSearchPanel2" position="right" :style="{ height: '100%', width: '80%' }">
                        <search-panel :type="searchPanelType2" @search="searchByPanel"></search-panel>
                    </van-popup>
                </div>
                <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">

                    <div class="item" v-for="item3 in dataList" :key="item3.id">
                        <div class="info">
                            <div class="top">
                                <div class="dot"></div>
                                <div class="name">
                                    {{item3.company.name}}
                                </div>
                            </div>
                            <div class="content">
                                <div class="desc">
                                    <span>公司简介：</span>
                                    <span> {{item3.company.introduction}}</span>
                                </div>
                                <div class="field">
                                    <span>行业：</span>
                                    <span>
                                        <span v-for="fd in industryFieldArr(item3.company.industryField)" :key="fd">
                                            {{fd}}
                                        </span>
                                    </span>
                                </div>
                                <div class="area">
                                    <span>上市地点：</span>
                                    <span>{{item3.stockExchangeName}}</span>
                                </div>
                                <div class="area">
                                    <span>上市时间：</span>
                                    <span> {{getDate(item3.listDate)}}</span>
                                </div>
                                <div class="area">
                                    <span>持有时长：</span>
                                    <span>{{calcDate(item3.holdingDays)}}</span>
                                </div>
                                <div class="invest">
                                    <div class="left">
                                        <div class="key">首次投资时间</div>
                                        <div class="value" v-if="item3.firstFund">{{getDate(item3.firstFund.fundingDate)}}</div>
                                    </div>
                                    <div class="center">
                                        <div class="key">首次投资轮次</div>
                                        <div class="value" v-if="item3.firstFund">{{item3.firstFund.round}}</div>
                                    </div>
                                    <div class="right">
                                        <div class="key">投资次数</div>
                                        <div class="value">{{item3.investCnt}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </van-list>
            </div>
        </div>

        <van-overlay :show="showOverlay">
            <div class="wrapper" @click.stop>
                <van-loading class="" />
            </div>
        </van-overlay>
    </div>
</template>

<script>
import webService from "@network/webService";
import common from "@common/common";
import SearchPanel from "@components/common/SearchPanel";

export default {
    data() {
        return {
            showOverlay: false,
            loading: false,
            finished: false,
            dataList: [],
            currentPage: 0,
            showSearchPanel: false,
            showSearchPanel2: false,
            searchPanelType: common.searchTypeEnum.exitIPO,
            searchPanelType2: common.searchTypeEnum.exitIPO2,
            oldSearchModel: {},
            isUp: false,
            isDesc: true,
            filterNum: null,
        };
    },

    components: {
        SearchPanel,
    },

    computed: {},

    mounted() {},

    methods: {
        changeTimeOrder() {
            this.isDesc = !this.isDesc;
            this.isUp = !this.isUp;
            this.currentPage = 0;
            this.dataList = [];
            this.onLoad();
        },
        showSearch(num) {
            this.filterNum = num;
            if (num == 1) {
                this.showSearchPanel = true;
            } else {
                this.showSearchPanel2 = true;
            }
        },
        searchByPanel(searchParams) {
            if (searchParams.hasFilter) {
                if (this.filterNum == 1) {
                    document
                        .getElementById("industry-filter1")
                        .classList.add("has-filter");
                } else {
                    document
                        .getElementById("stocking-location-filter1")
                        .classList.add("has-filter");
                }
            } else {
                if (this.filterNum == 1) {
                    document
                        .getElementById("industry-filter1")
                        .classList.remove("has-filter");
                } else {
                    document
                        .getElementById("stocking-location-filter1")
                        .classList.remove("has-filter");
                }
            }
            this.currentPage = 0;
            this.dataList = [];

            this.oldSearchModel.stockExchanges = searchParams.stockExchanges;
            this.oldSearchModel.orgIndustry = searchParams.orgIndustry;

            this.showSearchPanel = false;
            this.showSearchPanel2 = false;
            this.onLoad();
        },
        onLoad() {
            this.showOverlay = true;
            var id = this.$route.query.id;
            var param = {
                PageSize: 20,
                Page: this.currentPage,
                OrderType: this.isDesc ? 2 : 1,
                stockExchanges: this.oldSearchModel.stockExchanges,
                orgIndustry: this.oldSearchModel.orgIndustry,
            };
            webService.getExitIPOList(id, param).then((res) => {
                console.log(res);
                this.showOverlay = false;
                for (let i = 0; i < res.data.length; i++) {
                    this.dataList.push(res.data[i]);
                }
                this.loading = false;

                // debugger;
                if (res.data.length <= 0) {
                    this.finished = true;
                }
                this.currentPage++;
            });
        },
        goBack() {
            this.$router.go(-1);
        },
        calcDate(days) {
            if (days >= 365) {
                var years = (days * 1.0) / 365;
                return years.toFixed(2) + "年";
            } else {
                var mons = (days * 1.0) / 30;
                return mons.toFixed(2) + "个月";
            }
        },
        industryFieldArr(fields) {
            // debugger;
            if (fields) {
                return _.split(fields, ",", 4);
            } else {
                return [];
            }
        },
        getSubContent(cont) {
            let contentsArr = JSON.parse(cont);
            for (let i = 0; i < contentsArr.length; i++) {
                let obj = contentsArr[i];
                if (common.isEmpty(obj.image) && !common.isEmpty(obj.content)) {
                    return obj.content;
                }
            }
        },
        getDate(date) {
            if (!common.isEmpty(date)) {
                return this.$moment(date).format("yyyy/MM/DD");
            } else {
                return "None";
            }
        },
        goNewsDetail(id) {
            this.$router.push({
                path: "/newsDetail",
                query: {
                    id: id,
                    type: 0,
                },
            });
        },
    },
};
</script>

<style lang='less' scoped>

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.inner-main {
    height: 100%;
}

.main {
    height: calc(100% - 63px);
}
.header {
    padding: 1rem;
    padding-bottom: 10px;
}
.back-info {
    font-size: 34px;
    color: #7d7d7d;
}

.fundding {
    height: 99%;
}
/deep/ .van-list {
    height: calc(100% - 110px);
    overflow: auto;
    padding-top: 30px;
}
.fundding {
    .news-title {
        padding: 0.25rem 1.125rem 1rem 1.125rem;
        margin-bottom: 30px;
        margin-bottom: 10px;
        font-size: 26px;
        color: #2d2d2d;
        font-weight: 550;
    }
    .filter {
        display: flex;
        border-bottom: 1px solid #dedede;
        margin-bottom: 8px;
        color: #7d7d7d;
        padding: 0 1.125rem 0.5rem 1.125rem;
        .left {
            flex: 1;
        }
        .center {
            flex: 1;
            text-align: center;
        }
        .right {
            flex: 1;
            text-align: right;
        }
    }

    .item:not(:nth-of-type(1)) {
        padding: 1.125rem;
        padding-top: 20px;
    }
    .item {
        margin: 1.125rem;
        border-left: 1px solid #dedede;
        .info {
            padding: 0.625rem 0.625rem 0.625rem 0.625rem;
            position: relative;
            .top {
                position: absolute;
                display: flex;
                top: -10px;
                left: -5px;
                width: 100%;
                .dot {
                    background: #c52a1a;
                    border-radius: 50%;
                    height: 0.625rem;
                    width: 0.625rem;
                    // left: 0;
                    // top: 7px;
                    // transform: translateX(-50%);
                }
                .name {
                    position: absolute;
                    left: 16px;
                    top: -7px;
                    font-size: 16px;
                    font-weight: bold;
                    color: #464646;
                    width: 100%;
                }
            }
            .content {
                .desc,
                .field,
                .area {
                    line-height: 30px;
                    font-size: 14px;
                    color: #464646;
                }

                .invest,
                .invest2 {
                    margin-top: 16px;
                    margin-bottom: 16px;
                    display: flex;
                    .left,
                    .center,
                    .right {
                        flex: 1;
                    }
                    .key {
                        color: #7d7d7d;
                        font-size: 12px;
                        margin-bottom: 8px;
                    }
                    .value {
                        font-size: 14px;
                        color: #000000;
                    }
                }
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/content/org/ListExitIPO.vue